import { getByCurso } from "@/api/grupos.api"

const state = {

    groups: []

}

const getters = {

    /**
     * Return the groups
     * 
     */

    getGroups(state) {

        return state.groups

    },

    /**
     * Return grupos by ID
     * 
     */
    getGroupsById: (state) => (id) => {

        return state.groups.filter(function(group) {

            return group.id == id

        })

    },

    /**
     * Return grupos by Nivel ID
     * 
     */

    getGroupsByNivelId: (state) => (id) => {

        return state.groups.filter(function(group) {

            return group.nivel.id == id

        })

    }

}

const actions = {

    /**
     * Get groups by curso
     * 
     */

    async getGroupsByCourse({ dispatch, commit },{idCurso,page,idLocalizacion,componentId}) {

        try {

            const query = await getByCurso(idCurso,page,idLocalizacion)

            if(query.status == 200) {

                commit('SET_GROUPS', { groups: query.data })

            } else {

                dispatch('Errors/setError', { error:'CODE02', componentId: componentId }, { root: true })

            }

        } catch (error) {

            //console.log(error.response.data.code)
            //console.log('handle errors')

            dispatch('Errors/setError', { error:'CODE01', componentId: componentId }, { root: true })

        }

    }

}

const mutations = {

    /**
     * Set groups to the state
     * 
     */
    
    SET_GROUPS(state, data) {

        state.groups = data.groups

    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}